// Polyfill to ensure numberingSystem and calendar options are respected where Intl.DateTimeFormat is
// available, or define it supporting only `latn` and `gregory` where not available.
const global = window;
if (!global.Intl) {
    global.Intl = {};
}

const DateTimeFormat = global.Intl.DateTimeFormat;
const haveFormat =
    $build.platform == 'android' ||
    $build.platform == 'ios' ||
    !!DateTimeFormat;
const haveNumberingSystem = haveFormat && new DateTimeFormat('ar-SA', { numberingSystem: 'latn' }).resolvedOptions().numberingSystem == 'latn';
const enUS = 'en-US';
const re_lang = /[a-zA-Z0-9]+/;


if (!haveFormat) {
    global.Intl.DateTimeFormat = function(locales, options = {}) {
        let timeZone = options.timeZone;
        if (timeZone != null && !/^UTC$/i.test(timeZone)) {
            throw new RangeError('Unsupported time zone');
        }

        let year = options.year;
        let month = options.month;
        let day = options.day;
        let weekday = options.weekday;
        let hour = options.hour;
        let minute = options.minute;
        let second = options.second;

        if (!(weekday || year || month || day || hour || minute || second)) {
            year =
            month =
            day = 'numeric';
        }

        let resolvedOptions = {
            locale: enUS,
            calendar: 'gregory',
            numberingSystem: 'latn'
        };

        const lang = resolvedOptions.locale.match(re_lang);
        const num = { numeric: 1, '2-digit': 2 };
        const txt = { narrow: '.slice(0,1)+', short: '.slice(0,3)+', long: '+' };
        const get = timeZone ? 'd.getUTC' : 'd.get';
        const sep =
            lang == 'ar' || lang == 'he' ? '"\\u200f/"' :
            lang == 'de' || lang == 'ru' ? '"."' : '"/"';

        const format = new Function('d', 'if(!(d instanceof Date))d=new Date(d);return ' +
            (txt[weekday]
                ? '["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][' + get + 'Day()]' + txt[weekday] + '", "+'
                : '') +
            (txt[month]
                ? '["January","February","March","April","May","June","July","August","September","October","November","December"][' + get + 'Month()]' + txt[month] + (num[day] || num[year] ? '" "+' : '')
                : '') +
            (num[month]
                ? '(' + get + 'Month()+1)+' + sep + '+'
                : '') +
            (num[day]
                ? get + 'Date()+' + (num[year] ? (num[month] ? sep : '", "') + '+' : '')
                : '') +
            (num[year]
                ? get + 'FullYear()+'
                : '') +
            (num[hour] || num[minute] || num[second]
                ? (txt[month] || num[month] || num[year] ? '", "+' : '')
                : '') +
            (num[hour]
                ? '(' + get + 'Hours()%12||12)+' + (num[minute] ? '":"+' : '')
                : '') +
            (num[minute]
                ? '("0"+' + get + 'Minutes()).slice(-2)+' + (num[second] ? '":"+' : '')
                : '') +
            (num[second]
                ? '("0"+' + get + 'Seconds()).slice(-2)+'
                : '') +
            (num[hour]
                ? '(' + get + 'Hours()<12?" AM":" PM")+'
                : '') +
            '""');

        this.format = format;
        this.resolvedOptions = () => ({ ...resolvedOptions });
    }

    Date.prototype.toLocaleString = function(locales, options) {
        return new Intl.DateTimeFormat(locales, options).format(this);
    }
}

else if (!haveNumberingSystem) {
    global.Intl.DateTimeFormat = function(locales, options = {}) {
        let native = new DateTimeFormat(locales, options);
        let resolvedOptions = native.resolvedOptions();
        let format;

        // Firefox does not respect request for Gregorian calendar for some regions; try without region
        if (options.calendar == 'gregory' && resolvedOptions.calendar != 'gregory') {
            native = new DateTimeFormat(resolvedOptions.locale.match(re_lang), options);
            resolvedOptions = native.resolvedOptions();
        }

        // Firefox and Safari do not respect request for Latin numbering system for Arabic ever
        if (options.numberingSystem == 'latn' && resolvedOptions.numberingSystem == 'arab') {
            const convert = { '٠':0, '١':1, '٢':2, '٣':3, '٤':4, '٥':5, '٦':6, '٧':7, '٨':8, '٩':9 };
            format = date => native.format(date).replace(/[\u0660-\u0669]/g, ch => convert[ch]);
            resolvedOptions.numberingSystem = 'latn';
        } else {
            format = native.format.bind(native);
        }

        this.format = format;
        this.resolvedOptions = () => ({ ...resolvedOptions });
    }
}
